import { FormikValues } from 'formik'

export interface CreateRatingComplianceRuleValues extends FormikValues {
  rating: string
  ratingType: string
  maxLimit: number
}

export const createRatingComplianceRuleValues: CreateRatingComplianceRuleValues = {
  rating: null,
  ratingType: null,
  maxLimit: 0,
}
